/**
 * Maximum number of records allowed for table export (Excel/PDF/report download).
 */
export const TABLE_EXPORT_MAX_RECORDS = 3000;
